import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchThemeData } from "../../themeSlice";
import { selectOrganizationId, selectSessionId } from "../../sessionSlice";
import TabMenu from "../tabmenu/TabMenu";
import "./automatic.css";

const ALL_CATEGORIES = [
  "top_line",
  "middle_line",
  "bottom_line",
  "four_corners",
  "full_house",
  "early_five",
  "no_luck",
  "unlucky_five",
];

const formatClaimLabel = (key) =>
  key
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

const Automatic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const organizationId = useSelector(selectOrganizationId);
  const sessionId = useSelector(selectSessionId);
  const { currentTheme, data } = useSelector((state) => state.theme);

  const claimFromUrl = searchParams.get("claim") || ALL_CATEGORIES[0];
  const [currentClaim, setCurrentClaim] = useState(claimFromUrl);
  const [claimsList, setClaimsList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentTheme) dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  useEffect(() => {
    setCurrentClaim(claimFromUrl);
  }, [claimFromUrl]);

  useEffect(() => {
    if (!organizationId || !sessionId || !currentClaim) {
      setClaimsList([]);
      return;
    }
    setLoading(true);
    const fetchClaims = async () => {
      try {
        // Replace with real API when backend provides automatic claims endpoint
        // e.g. GET /api/automatic-claims?organizationId=&sessionId=&claim=
        setClaimsList([]);
      } catch {
        setClaimsList([]);
      } finally {
        setLoading(false);
      }
    };
    fetchClaims();
  }, [organizationId, sessionId, currentClaim]);

  const selectClaim = (key) => {
    setSearchParams({ claim: key });
    setCurrentClaim(key);
  };

  return (
    <div className="automatic-page">
      <div className="automatic-back-button-holder">
        <button
          type="button"
          className="automatic-back-button"
          onClick={() => navigate("/admin/rules")}
        >
          <i className="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>

      <TabMenu />

      <div className="automatic-card-wrap">
        <div className="automatic-card">
          <div className="automatic-card-header">View all claims</div>
          <div className="automatic-card-body">
            <div className="automatic-buttons">
              {ALL_CATEGORIES.map((key) => (
                <button
                  key={key}
                  type="button"
                  className={`automatic-btn ${currentClaim === key ? "active" : ""}`}
                  onClick={() => selectClaim(key)}
                >
                  {formatClaimLabel(key)}
                </button>
              ))}
            </div>

            <div className="automatic-table-wrap">
              {loading ? (
                <div className="automatic-loading">Loading claims...</div>
              ) : (
                <table className="automatic-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Category</th>
                    </tr>
                  </thead>
                  <tbody>
                    {claimsList.length === 0 ? (
                      <tr>
                        <td colSpan={3} className="automatic-empty">
                          No claims for this category. Connect automatic claims API to show results.
                        </td>
                      </tr>
                    ) : (
                      claimsList.map((row, idx) => (
                        <tr key={row.id || idx}>
                          <td>{row.name}</td>
                          <td>{row.email || "—"}</td>
                          <td>{formatClaimLabel(row.claim || currentClaim)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Automatic;
